module.exports = __webpack_public_path__ + "0.7.9/img/jcd_logo.1bbffd7e.png";